export const usuriosAntiguos = (creditos) =>
  creditos.filter((credito) => credito?.cuentaUsuario?.antiguo === true);
